module.exports = __webpack_public_path__ + "static/media/16UNODC5.bedb8830.jpg";